import React, { useEffect, useState } from 'react'
import useReduxState from "../../../hooks/useReduxState";
import EditProject from './EditProject';
import BomListUl from './BomListUl';
import { Drop } from "../../../component/Global/DragAndDrop/Drop";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import { __remove, __set } from 'src/store/axios_indicator';

const ProjectList = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ your_bom_listing, bom_project_list }, { fetch_bom_project_detail_with_bom }, { }] = useBOMStore();
    const [activeToEditBOMProject, setActiveToEditBOMProject] = useState({});
    const [find_bom_input_bom_listing] = useReduxState({}, 'find_bom_input_bom_listing');
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);

    useEffect(() => {
        async function fetchHere() {
            __set('BOM_PROJECT_API_CALL_GUEST');
            await fetch_bom_project_detail_with_bom();
            setFirstServerCall(false)
            __remove('BOM_PROJECT_API_CALL_GUEST');
        }
        fetchHere()
    }, []);

    const getDisplayStatus = (singleProject) => {
        if (find_bom_input_bom_listing.trim().length > 0) {
            let isBomMatch = false
            if (Object.keys(singleProject.bom_listing).length > 0) {
                Object.entries(singleProject.bom_listing).map((v) => {
                    if (v[1].bomName.toLowerCase().includes(find_bom_input_bom_listing.toLowerCase())) {
                        isBomMatch = true;
                    }
                })
            }
            return isBomMatch
        } else {
            return true
        }
    };

    const addProjectToEditStack = (singleProject) => {
        let a = { ...activeToEditBOMProject };
        if (a[singleProject.projectId] !== undefined) {
            delete a[singleProject.projectId];
        } else {
            a[singleProject.projectId] = singleProject;
        }
        setActiveToEditBOMProject(a);
    };

    useEffect(() => {
        if (!firstServerCall && !monitorFunctionCall) {
            System.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [your_bom_listing])

    return (
        <>
            {bom_project_list && Object.entries(bom_project_list).length > 0 &&
                Object.entries(bom_project_list).map((v, i) => (
                    <React.Fragment key={v[1].projectId}>
                        {getDisplayStatus(v[1]) &&
                            <React.Fragment key={v[1].projectId}>
                                <Drop data={v[1]}>
                                    <div className="accordion mt-4 mb-3" id="test-project">
                                        <div className="accordion-item position-relative">
                                            <div>
                                                {__check(['BOM_PROJECT_API_CALL', 'BOM_ASSIGN_TO_PROJECT_API_CALL'], { overlay: true }).render}
                                            </div>
                                            <h2 className="accordion-header mb-0" id="headingOne">

                                                <button className="accordion-button" type="button" data-toggle="collapse"
                                                    data-target={"#collapse" + i} aria-expanded="true"
                                                    aria-controls={"collapse" + i}>
                                                    {!activeToEditBOMProject[v[1].projectId] && <b className="font-24 m-t-10 ellipses" title={v[1].projectName}>{v[1].projectName}</b>}
                                                </button>

                                            </h2>
                                            {!activeToEditBOMProject[v[1].projectId] &&
                                                <p className="w-100 ps-3 m-b-20"><a className="text-blue2 font-arial font-13" href={void (0)}
                                                    onClick={async () => { addProjectToEditStack(v[1]) }}
                                                >Edit Project</a> <span className='px-1'>|</span> <a
                                                    className="text-blue2 font-arial font-13" data-toggle="modal" href={void (0)}
                                                    onClick={() => {
                                                        System.popup('BomDeleteProjectPopup', { projectId: v[1].projectId, projectName: v[1].projectName })
                                                    }}>Delete Project</a></p>
                                            }
                                            {activeToEditBOMProject[v[1].projectId] &&
                                                <EditProject projectData={v[1]}
                                                    addProjectToEditStack={(e) => addProjectToEditStack(e)} />
                                            }
                                            <div id={"collapse" + i} className="accordion-collapse collapse in"
                                                aria-labelledby="headingOne"
                                                data-parent="#accordionExample">
                                                <div className="accordion-body p-0">
                                                    { }
                                                    <BomListUl
                                                        listOfBOM={v[1].bom_listing}
                                                        project_id={v[1].projectId} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Drop>
                            </React.Fragment>
                        }
                    </React.Fragment >
                ))
            }
        </>
    );
}

export default ProjectList;